import { render, staticRenderFns } from "./CharityBarAlipay.vue?vue&type=template&id=0db9d812&scoped=true&lang=pug"
import script from "./CharityBarAlipay.vue?vue&type=script&lang=js"
export * from "./CharityBarAlipay.vue?vue&type=script&lang=js"
import style0 from "./CharityBarAlipay.vue?vue&type=style&index=0&id=0db9d812&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9d812",
  null
  
)

export default component.exports